import React from "react";
import { Row, Col, Label, Button } from "reactstrap";
import { inject, observer } from "mobx-react";
import CardContainerFilho from "./CardContainerFilho";
import CardContainerPaiStore from "../stores/CardContainerPaiStore";
import FormSelect from "../../../../comum/components/FormSelect";
import FormInput from "../../../../comum/components/FormInput";
import {isInvalidoCodigoContainer} from "../../../../../utils/validadores"
import {
  IconeDelete,
  IconeEditar,
  IconeBuscar,
  IconeSetaSubir,
  IconeSetaDescer,
  IconeGenerico,
} from "../../../../comum/components/Icones";
import ModalAviso from "../../../../comum/components/ModalAviso";
import moment from "moment";
import hrefDestinosZip from "../../../../../assets/downloads/Tecon_Rio_Grande_Lista_Destino_Final.xlsx";
import LoadingImage from "../../../../comum/components/LoadingImage";

@inject("store")
@observer
export default class CardContainerPai extends React.Component {
  constructor(props) {
    super(props);
    if (this.props.agendamento.isEditar) this.atualizaEditar();
    this.appStore = this.props.store.appStore;
    this.parametrosStore = this.props.store.parametrosStore;
    this.controller = new CardContainerPaiStore(this.props.tipoAgenda);
    this.codigoBooking = this.props.codigoBooking;
    this.containerExcluido = null;
    this.state = {
      refreshBooking: false,
      refreshContainer: false,
      armador: null,
      tipoConsultaState: false,
      excluido: false
    };

    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnChangeContainer = this.handleOnChangeContainer.bind(this);
    this.expandido = this.props.booking.collapsed;
    if (!this.props.agendamento.isEditar) this.handleOnChangeTipoConsultaCntrAposDelete(this.props.agendamentoController.tipoConsultaAnterior)
    if (this.props.agendamento.isEditar) this.ComponentEditar()
  }



  refresh = () => {
    this.setState({ refreshBooking: false });
    setTimeout(
      function () {
        this.setState({ refreshBooking: true });
      }.bind(this),
      1
    );
  };

  atualizaEditar = () => { 
    this.props.booking.containers.map((container, index) => {
      if(index != this.props.booking.containerAtivo){
        container.isEscondido = true;
      } else {
        container.isEscondido = false;
      }
    })
    // this.props.booking.containerAtivo = 9999999;
    console.log('teste4 de dados pelo console',  this.props.booking.containers)
  }


  ComponentEditar = async () => { 
    if (this.props.agendamento.isEditar) {
      await this.controller.service
      .ListarTipoConsultaImportDepot(
        this.props.booking.containers[0].CodCntr
      ).then((response) => {
        console.log(response)
        if (response.data.length > 0) {
          this.handleOnChangeTipoConsultaCntrAposDelete(response.data)
          this.props.booking.containers.map((event, index)=>{
          if(!this.controller.arrayJaVistoEditar.includes(index)){
         
            this.handleOnChangeContainerEditar(event.CodCntr, index)
            this.controller.arrayJaVistoEditar.push(index);
          }
        })
      }
      });
    }
  }

  handleRemover = () => this.props.remover(this.props.index);

  handleRemoverContainer = (index, posContainer) => {
    this.containerExcluido = posContainer;

    this.props.removerContainer(index, posContainer);
    setTimeout(
      function () {
        this.setState({ refreshContainer: true });
      }.bind(this),
      1
    );
    // _.set(
    //   this.props.agendamento.dadosAgendamento,
    //   `Containeres`,
    //   []
    // );
    this.props.agendamento.removeContainerEntradaImportacao(index)
    this.props.refreshAoContrario(this.controller.tipoConsultaCntr)

    this.handleOnChangeTipoConsultaCntrAposDelete(this.controller.tipoConsultaCntr)
    this.setState({ tipoConsultaState: true });
    
    console.log('tipo consulta', this.props)
    this.setState({ excluido: true });
  };

  handleDuplicad = () => this.props.duplicar(this.props.index);

  handleOnChangeContainerEditar = (container, pos) => {
    if (container != null || container != undefined) {
      console.log('container', container, this.props.booking.containers)

      if(container.length === 0)
      return;
    var dado = container;
    this.controller.loadingCtnrFromExternalApi[pos] = true;
    
    this.props.setDado(
      `${this.props.dado}.containers[${pos}].CodCntr`,
      container
    );
    console.log('dado', dado)
      if (dado != null) {
        if (dado.trim().length > 0) {
          this.controller.service
            .ListarPreviaImportDepot(
              this.controller.tipoConsultaCntr,
              dado
            )
            .then((response) => {
              console.log('response, edutar', response)
              if (response.data.Content != null) {
                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].armador`,
                  { value: response.data.Content.ApelidoArmador }
                );
                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].CodIso`,
                  { value: response.data.Content.CodIso }
                );
                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].ArmId`,
                  { value: response.data.Content.ArmId }
                );
                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].CodCntr`,
                  { value: response.data.Content.CodCntr }
                );
                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].horaEvento`,
                  { value: response.data.Content.EventDt }
                );
                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].peso`,
                  { value: response.data.Content.Weight }
                );
                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].local`,
                  { value: response.data.Content.PlaceNm }
                );
                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].terminal`,
                  { value: response.data.Content.YardNm }
                );
                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].status`,
                  { value: response.data.Content.StatusNm }
                );
                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].tipo`,
                  { value: response.data.Content.CntrTpszNm }
                );
                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].navioViagem`,
                  { value: response.data.Content.NavioViagem }
                );
                
                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].existsOnApi`,
                  { value: true }
                );

                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].PreviaImportacaoDepot`,
                  { value: response.data.Content.PreadviseCntrId }
                );
                _.set(this.props.agendamento.dadosAgendamento, `Containeres[${pos}]`, response.data.Content);
                this.controller.previaNaoExisteFilho = true;
                this.controller.previaNaoExisteFilho = false;
              } else {
                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].armador`,
                  { value: null }
                );
                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].navioViagem`,
                  { value: null }
                );
                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].horaEvento`,
                  { value: null }
                );
                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].peso`,
                  { value: null }
                );
                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].local`,
                  { value: null }
                );
                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].terminal`,
                  { value: null }
                );
                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].status`,
                  { value: null }
                );
                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].tipo`,
                  { value: null }
                );
                this.props.setDado(
                  `${this.props.dado}.containers[${pos}].existsOnApi`,
                  { value: false }
                );
                this.controller.msg =
                  response.data.Message;
                this.controller.previaNaoExiste = true;
                this.controller.previaNaoExisteFilho = true;
              }
            })
            .catch(ex =>{
              console.log("error ",ex)
            }).finally(() =>{
              this.controller.loadingCtnrFromExternalApi[pos] = false;
            });
        }
      }
    }
    
  }


  handleContainersVazio = () => {};

  handleSelecionaContainer = (posContainer, CdTipoCntr) => {
    this.controller.previaNaoExisteFilho = false;
    this.props.booking.containers.map((i, index) => {
      if (index != posContainer) {
        i.isEscondido = true;
      } else {
        i.isEscondido = false;

        this.props.agendamentoController.dadosAgendamento.listaBookings[0].containerAtivo =
          index;
      }
    });
  };

  tipoConsultaReturn = () => {
    this.setState({ tipoConsultaState: false });
    return (
      <div></div>
    )
  }

  listaContainers() {
  

    return (
      <div>
        <Row>
          <Col className="area-form" xs={12} sm={6} lg={4}>
            {/* <FormSelect xs={12} sm={12} md={6} titulo="Transportadora"
                            itens={this.controller.transportadoras}
                            objeto={this.controller.dadosAgendamento}
                            dado={ process.env.ssa  && ["DRE","DRED","DREDA","DDI"].indexOf(this.controller.tipoAgendaAtivo.codIdentificador) > -1 ? "Agend.TranspIdDepot" : "Agend.TranspId"}
                            itensValor="TranspId" itensLabel="ApelidoTransp"
                            bloqueado={this.bloqueiaTransp()}
                            //alerta={ (this.state.salvo && !_.has(this.controller.dadosAgendamento, "Agend.TranspId")) ? "Campo obrigatório" : "" }
                            onChange={this.handleChangeTransportadora} /> */}

            {!this.state.tipoConsultaState && <FormSelect
              xs={12}
              sm={12}
              md={6}
              titulo="Tipo da Consulta"
              bloqueado={this.props.agendamento.isEditar}
              objeto={this.controller.tipoConsultaCntr}
              placeholder={this.controller.tipoConsultaCntr}
              itens={ !this.props.agendamento.isEditar ?  [
                {
                  TipoConsulta: "Geral",
                },
                // {
                //   TipoConsulta: "Hapag",
                // },

                {
                  TipoConsulta: "One",
                },
              ] : [
                {
                  TipoConsulta: "Geral",
                }, {
                  TipoConsulta: "One",
                },]}
              itensValor="TipoConsulta"
              itensLabel="TipoConsulta"
              onChange={(event) =>
                this.handleOnChangeTipoConsultaCntr(event, this.value)
              }
            />}
          </Col>
        </Row>
        <Row>
          <Col>
            <h2>Containers</h2>
          </Col>
        </Row>

        <Row className="sub-detalhes">
          <Col md={3}>
            {this.props.booking.containers.map((container, posContainer) => (
              <div
                key={posContainer}
                className={ 
                `card-branco clicavel ${
                  this.props.booking.containerAtivo === posContainer &&
                  "card-selecionado"
                }`}
                onClick={() =>
                  this.handleSelecionaContainer(
                    posContainer,
                    container.CdTipoCntr
                  )
                }
              >
                <Row>
                  <Col xs={6} sm={6} md={8}>
                    {
                      <FormInput
                        classNames={"input-titulo"}
                        objeto={this.props.booking.containers[posContainer]}
                        dado={`CodCntr`}
                        limiteMaximo={11}
                        bloqueado={this.props.agendamento.isEditar}
                        onChange={(event) =>
                          this.handleOnChangeContainer(
                            event,
                            this.props.index,
                            posContainer,
                            this.value
                          )
                        }
                        placeholder="Nº Container"
                      />
                    }
                  </Col>
                  {!this.props.agendamento.isEditar && <Col xs={6} sm={6} md={4}>
                    <div className="float-right">
                      <IconeDelete
                        tamanho="lg"
                        onClick={() =>
                          this.handleRemoverContainer(
                            this.props.index,
                            posContainer
                          )
                        }
                      />
                      {this.controller.loadingCtnrFromExternalApi[posContainer] && <LoadingImage  /> }
                    </div>
                  </Col>}
                </Row>
                <Row>
                  {container.padraoContainer && (
                    <Col className=" ml-4 col-label label-obrigatorio px-0">
                      <Label>Padrão inválido</Label>
                    </Col>
                  )}
                </Row>
              </div>
            ))}
             {!this.props.agendamento.isEditar && <div
              className="card-inserir-novo clicavel"
              onClick={() => this.props.adicionarNovoContainer(this.props.index) 
                
              }
            >
              <Row>
                <Col>
                  <Label className="clicavel">Novo Container</Label>
                </Col>
              </Row>
            </div> }
          </Col>
          {
            //(!this.props.isEditar || this.controller.ISOs) &&
            this.state.refreshContainer ? this.excluiDadosContainers() : this.props.booking.containers &&
            this.props.booking.containers.map((container, posContainer) => container.CodCntr != undefined &&
                container.CodCntr.length > 0 &&
                !this.controller.previaNaoExisteFilho ? (
                  <CardContainerFilho
                    index={posContainer}
                    key={posContainer}
                    isEscondido={container.isEscondido}
                    booking={this.props.booking}
                    controller={this.controller}
                    agendamentoController={this.props.agendamentoController}
                    dado={`${this.props.dado}.containers[${posContainer}]`}
                    container={container}
                    setStatusSalvo={this.props.setStatusSalvo}
                    setDado={this.props.setDado}
                    armadorEstado={this.state.armador}
                    agendamento={this.props.agendamento}
                  />
                ) : null
              )
          }
        </Row>
      </div>
    );
  }

  excluiDadosContainers = () => {
    setTimeout(() => {
      this.setState({ refreshBooking: false, refreshContainer: false });
    }, 1000);
    return <div></div>;
  };

  listaDeCodCntr = () => {
    let lista = "";
    if (this.props.booking.containers)
      this.props.booking.containers.forEach((cntr, x) => {
        if (x > 0) {
          lista = lista + "  /  ";
        }
        lista = lista + cntr.CodCntr;
      });
    return lista;
  };

  modalErro() {
    if (this.controller.listaMensagens) {
      return (
        <ModalAviso onClickFechar={() => this.controller.fecharModais()}>
          {this.controller.listaMensagens &&
            this.controller.listaMensagens.map((msg, x) => (
              <h2 key={x}>{msg}</h2>
            ))}
        </ModalAviso>
      );
    }
  }

  isCodigoNovo() {
    return this.props.booking.bookingExistente;
  }

  habilitarEdicaoBooking = () => {
    _.set(
      this.props.booking,
      "NumBookingTemp",
      _.get(this.props.booking, `NumBooking`)
    );
    this.controller.editandoBooking = true;
  };

  validarDestino = (event) => {
    this.props.setDado(`${this.props.dado}.LcCdLoc`, event);

    if (["DREDD"].includes(this.props.tipoAgenda.codIdentificador))
      this.controller.carregarCategorias(_.get(this.props.booking, `LcCdLoc`));
  };

  handleOnChange = (event) => {
    this.props.setDado(`${this.props.dado}.NumBookingTemp`, event);
  };

  handleValidaContainerJaExistente = (numero, posContainer) => {  
    return this.props.booking.containers
      .filter((_, index) => index !== posContainer)
      .some(x => x.CodCntr == numero);
  }

  handleOnChangeContainer = (event, posBooking, posContainer, valu) => {
    this.controller.loadingCtnrFromExternalApi = [];
    this.props.booking.containers.map((container) => {
      this.controller.loadingCtnrFromExternalApi.push(false)
   })
    const existe = this.handleValidaContainerJaExistente(event.target.value, posContainer);
    if(existe){
      this.controller.msg = "O container já existe no agendamento atual!"
      this.controller.previaNaoExiste = true;
      return;
    }
    if(event.target.value.length === 0)
      return;
    var dado = event.target.value;
    this.controller.loadingCtnrFromExternalApi[posContainer] = true;
    var prossegui = true;
    this.props.setDado(
      `${this.props.dado}.containers[${posContainer}].CodCntr`,
      event
    );
    this.controller.service
      .ValidaContainerExiste(event.target.value)
      .then((response) => {
        if(this.props.agendamento.isEditar){
          response.data.Sucesso = true;
        }
        if (response.data.Sucesso == false) {
          this.controller.msg = response.data.Mensagem;
          this.controller.previaNaoExiste = true;
          this.controller.previaNaoExisteFilho = true;
          prossegui = false;
          return;
        } else {
          if (prossegui) {
            if (dado != null) {
              if (dado.trim().length > 0) {
                this.controller.service
                  .ListarPreviaImportDepot(
                    this.controller.tipoConsultaCntr,
                    dado
                  )
                  .then((response) => {
                    if (response.data.Content != null) {
                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].armador`,
                        { value: response.data.Content.ApelidoArmador }
                      );
                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].CodIso`,
                        { value: response.data.Content.CodIso }
                      );
                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].ArmId`,
                        { value: response.data.Content.ArmId }
                      );
                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].CodCntr`,
                        { value: response.data.Content.CodCntr }
                      );
                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].horaEvento`,
                        { value: response.data.Content.EventDt }
                      );
                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].peso`,
                        { value: response.data.Content.Weight }
                      );
                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].local`,
                        { value: response.data.Content.PlaceNm }
                      );
                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].terminal`,
                        { value: response.data.Content.YardNm }
                      );
                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].status`,
                        { value: response.data.Content.StatusNm }
                      );
                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].tipo`,
                        { value: response.data.Content.CntrTpszNm }
                      );
                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].navioViagem`,
                        { value: response.data.Content.NavioViagem }
                      );
                      
                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].existsOnApi`,
                        { value: true }
                      );

                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].PreviaImportacaoDepot`,
                        { value: response.data.Content.PreadviseCntrId }
                      );
                      _.set(this.props.agendamento.dadosAgendamento, `Containeres[${posContainer}]`, response.data.Content);
                      this.controller.previaNaoExisteFilho = true;
                      this.controller.previaNaoExisteFilho = false;
                    } else {
                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].armador`,
                        { value: null }
                      );
                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].navioViagem`,
                        { value: null }
                      );
                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].horaEvento`,
                        { value: null }
                      );
                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].peso`,
                        { value: null }
                      );
                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].local`,
                        { value: null }
                      );
                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].terminal`,
                        { value: null }
                      );
                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].status`,
                        { value: null }
                      );
                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].tipo`,
                        { value: null }
                      );
                      this.props.setDado(
                        `${this.props.dado}.containers[${posContainer}].existsOnApi`,
                        { value: false }
                      );
                      this.controller.msg =
                       response.data.Message;
                      this.controller.previaNaoExiste = true;
                      this.controller.previaNaoExisteFilho = true;
                    }
                  })
                  .catch(ex =>{
                    console.log("error ",ex)
                  }).finally(() =>{
                    this.controller.loadingCtnrFromExternalApi[posContainer] = false;
                  });
              }
            }
          }
        }
      });
  };

  handleOnChangeTipoConsultaCntrAposDelete = (dado) => {
      if (dado.length > 0) {
        console.log('apos exluir', dado)
        this.controller.atualizaTipoConsultaCntr(dado);
        this.props.agendamento.tipoCadastroImportacaoEntrada = dado;
      }
    };

  handleOnChangeTipoConsultaCntr = (event) => {
    var dado = event.value;
    this.controller.atualizaTipoConsultaCntr(dado);
    this.props.agendamento.tipoCadastroImportacaoEntrada = dado;
    };

  modalErroSemPrevia() {
    const msg = this.controller.msg;
    if (this.controller.previaNaoExiste) {
      return (
        <ModalAviso
          onClickFechar={() =>
            this.controller.previaNaoExiste
              ? this.controller.fecharModaisErro()
              : this.controller.fecharModais()
          }
        >
          {<h2 key="semPrevia">{msg}</h2>}
        </ModalAviso>
      );
    }
  }

  render() {
    

    return (
      <div className="card-expansivel">
        {this.modalErroSemPrevia()}
        <div
          className={
            this.props.booking.collapsed
              ? "detalhes-ativo escondido"
              : "detalhes-ativo"
          }
        >
          <div className="detalhes">{this.listaContainers()}</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/importacao-entrada-depot/components/CardContainerPai.js